<template>
    <div>
        <marker-single
            v-for="(marker, index) in highwayMarkerArray"
            :key="`${marker.id}-${marker.type}-${index}`"
            :marker="marker"
        >
        </marker-single>
    </div>
</template>
<script>
import {
    LMarker,
    LPopup,
    LTooltip,
    LIcon,
} from "vue2-leaflet";
import {mapGetters} from "vuex";
import MarkerSingle from "./MarkerSingle.vue";
import Vue from "vue";

export default {
    components: {
        LPopup,
        LMarker,
        LTooltip,
        LIcon,
        MarkerSingle,
    },

    data() {
        return {
            highwayMarkerArray: [],
        };
    },

    mounted() {
        this.fillHighwayMarkerArray(this.highwayMarkers);
    },

    methods: {
        fillHighwayMarkerArray(newValue) {
            if (newValue.length) {
                let vm = this;
                let highwayMarkerArray = [];
                let filterKeys = Object.keys(this.filters);
                /***
                 * @param highway highway with all marker object contained
                 */
                newValue.forEach((highway, index) => {
                    let keys = newValue ? Object.keys(highway) : null;
                    // @TODO test and check everything updates
                    if (keys.length || filterKeys.length) {
                        keys.forEach((key) => {
                            // filter tollPlaces based on the applied filter on frontend
                            if (
                                key === "tollPlaces" &&
                                filterKeys.find((filter) => filter === "tollPlacesType")
                            ) {
                                highway[key].forEach((marker) => {
                                    let tollPlace = false;
                                    if (
                                        this.filters.tollPlacesType.find(
                                            (el) => el === "enc_regular"
                                        )
                                    ) {
                                        tollPlace = true;
                                    }
                                    if (
                                        this.filters.tollPlacesType.find(
                                            (el) => el === "enc_sale"
                                        ) &&
                                        marker.enc_sale
                                    ) {
                                        tollPlace = true;
                                    }
                                    if (
                                        this.filters.tollPlacesType.find(
                                            (el) => el === "enc_fill"
                                        ) &&
                                        marker.enc_fill
                                    ) {
                                        tollPlace = true;
                                    }
                                    if (
                                        marker.coordinates &&
                                        marker.coordinates.length &&
                                        tollPlace
                                    ) {
                                        highwayMarkerArray.push({
                                            ...marker,
                                            type: marker.type ? marker.type : key
                                        });
                                    }
                                });
                            } else if (
                                key === "restAreas" &&
                                filterKeys.find((filter) => filter === "gasStationTypes")
                            ) {
                                highway[key].forEach((marker) => {
                                    if (
                                        this.gasStationTypes.find(
                                            (gasstation) => gasstation === marker.type
                                        )
                                    ) {
                                        highwayMarkerArray.push({
                                            ...marker,
                                            type: marker.type ? marker.type : key,
                                            //@TODO gasStationTypes, restAreaTypes
                                        });
                                    }
                                });
                            } else {
                                // map other markers
                                if (filterKeys.find((filter) => filter === key)) {
                                    highway[key].forEach((marker) => {
                                        if (marker.coordinates && marker.coordinates.length) {
                                            if (key === "restAreas") {
                                                vm.filters[key].forEach((restAreaType) => {
                                                    if (marker[restAreaType] || restAreaType === 'all') {
                                                        highwayMarkerArray.push({
                                                            ...marker,
                                                            type: marker.type ? marker.type : key
                                                        });
                                                    }
                                                });
                                            } else {
                                                highwayMarkerArray.push({
                                                    ...marker,
                                                    type: marker.type ? marker.type : key
                                                });
                                            }
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
                Vue.set(vm, "highwayMarkerArray", highwayMarkerArray);
            }
        },
    },
    computed: {
        ...mapGetters([
            "highwayMarkers",
            "filters",
            "restAreas",
            "gasStationTypes",
        ]),
    },
    watch: {
        highwayMarkers(newValue) {
            if (newValue && newValue.length) {
                this.fillHighwayMarkerArray(newValue);
            }
        },
    },
};
</script>
